/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

/* Column options for report page, intial state */
export const columnOptionsQuays = [
  {
    id: "id",
    checked: true,
  },
  {
    id: "importedId",
    checked: true,
  },
  {
    id: "position",
    checked: true,
  },
  {
    id: "privateCode",
    checked: true,
  },
  {
    id: "publicCode",
    checked: true,
  },
  {
    id: "wheelchairAccess",
    checked: false,
  },
  {
    id: "stepFreeAccess",
    checked: false,
  },
  {
    id: "shelterEquipment",
    checked: false,
  },
  {
    id: "waitingRoomEquipment",
    checked: false,
  },
  {
    id: "sanitaryEquipment",
    checked: false,
  },
  {
    id: "generalSign",
    checked: false,
  },
];

export const columnOptionsStopPlace = [
  {
    id: "name",
    checked: true,
  },
  {
    id: "modality",
    checked: true,
  },
  {
    id: "id",
    checked: true,
  },
  {
    id: "county",
    checked: true,
  },
  {
    id: "muncipality",
    checked: true,
  },
  {
    id: "importedId",
    checked: false,
  },
  {
    id: "position",
    checked: false,
  },
  {
    id: "parking",
    checked: true,
  },
  {
    id: "wheelchairAccess",
    checked: false,
  },
  {
    id: "stepFreeAccess",
    checked: false,
  },
  {
    id: "shelterEquipment",
    checked: false,
  },
  {
    id: "waitingRoomEquipment",
    checked: false,
  },
  {
    id: "sanitaryEquipment",
    checked: false,
  },
  {
    id: "generalSign",
    checked: false,
  },
  {
    id: "tags",
    checked: true,
  },
];
